import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { CARD_THEMES } from './card_theme';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { ListingToolCall } from '../types';

interface ListingCard extends LinkCardRecord {
  address: string | null;
  displayName: string;
  listingType: string | null;
  status: string;
}

interface ListingCardsProps {
  toolCalls: ListingToolCall[];
}

export function ListingCards({ toolCalls }: ListingCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.listing}>
          {(listing: ListingCard) => {
            const details = [listing.address, listing.listingType].filter(Boolean).join(' • ');

            return (
              <>
                <div className="d-flex align-items-center gap-2">
                  <span className="fw-semibold text-truncate">{listing.displayName}</span>
                  <Badge appearance="muted" className="flex-shrink-0" variant="secondary">{listing.status}</Badge>
                </div>
                {details && <div className="small text-muted text-truncate">{details}</div>}
              </>
            );
          }}
        </LinkCard>
      ))}
    </>
  );
}
